export const COMPONENT_DATA_ATTRIBUTE_NAME = 'component-data';
